import { useEffect, useState, type ImgHTMLAttributes } from 'react';
import { getAttachment } from '@petrhythm/data';

/** 기기 안 첨부 하나를 화면에서 쓸 수 있는 주소로. 화면을 떠나면 주소를 돌려준다. */
export function useAttachmentUrl(id: string | undefined): { url: string | null; mime: string | null; missing: boolean } {
  const [state, setState] = useState<{ url: string | null; mime: string | null; missing: boolean }>({ url: null, mime: null, missing: false });
  useEffect(() => {
    if (!id) { setState({ url: null, mime: null, missing: false }); return undefined; }
    let active = true; let url: string | null = null;
    void getAttachment(id).then((row) => {
      if (!active) return;
      if (!row || row.deletedAt) { setState({ url: null, mime: null, missing: true }); return; }
      url = URL.createObjectURL(row.blob); setState({ url, mime: row.mime, missing: false });
    }).catch(() => { if (active) setState({ url: null, mime: null, missing: true }); });
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [id]);
  return state;
}

/** 사진이면 이미지, 영상이면 첫 장면을 보여 주는 작은 미리보기. 지운 첨부는 글자로 남긴다. */
export function AttachmentImage({ id, alt, ...props }: { id: string; alt: string } & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>) {
  const { url, mime, missing } = useAttachmentUrl(id);
  if (missing) return <span className="attachment-missing">첨부 지움</span>;
  if (!url) return <span className="attachment-loading" aria-hidden />;
  if (mime?.startsWith('video/')) return <video className={props.className} src={url} muted playsInline preload="metadata" aria-label={alt} />;
  return <img {...props} src={url} alt={alt} />;
}
